import m from "../../../../geodata/es2015/region/usa/wyHigh";
window.am4geodata_region_usa_wyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/wyHigh.js
// module id = null
// module chunks = 